import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Sidebar from "./components/SidebarLeft.jsx"; 
import SidebarRight from "./components/SidebarRight";
import TypingBox from "./components/TypingBox";

import jsLessons from "./data/js.jsx";
import pythonLessons from "./data/python.jsx";
import cLessons from "./data/cLessons.jsx";
import javaLessons from "./data/javaLessons.jsx";
import htmlLessons from "./data/htmlLessons.jsx";
import ScrollToTop from "./components/ScrolltoTop.jsx";

function App() {
  const allLanguages = ["JavaScript", "Python", "C", "Java", "HTML"];
  const lessonsData = { 
    JavaScript: jsLessons, 
    Python: pythonLessons, 
    C: cLessons, 
    Java: javaLessons, 
    HTML: htmlLessons 
  };

  const [currentLanguage, setCurrentLanguage] = useState("JavaScript");
  const [currentLesson, setCurrentLesson] = useState(lessonsData[currentLanguage][0]);

  useEffect(() => {
    setCurrentLesson(lessonsData[currentLanguage][0]);
  }, [currentLanguage]);

  const [wpm, setWpm] = useState(0);
  const [accuracy, setAccuracy] = useState(0);
  const [errors, setErrors] = useState(0);
  const [time, setTime] = useState(0);
  const [cpm, setCpm] = useState(0);
  const [kph, setKph] = useState(0);

  const goNextLesson = () => {
    const lessons = lessonsData[currentLanguage];
    const idx = lessons.findIndex((l) => l.title === currentLesson.title);
    if (idx < lessons.length - 1) setCurrentLesson(lessons[idx + 1]);
  };
  
  const goPrevLesson = () => {
    const lessons = lessonsData[currentLanguage];
    const idx = lessons.findIndex((l) => l.title === currentLesson.title);
    if (idx > 0) setCurrentLesson(lessons[idx - 1]);
  };

  const selectLesson = (selectedLesson) => setCurrentLesson(selectedLesson);

  return (
    <>
    <ScrollToTop/>
      <div className="min-h-screen bg-black text-white w-full overflow-x-hidden">
        {/* Navbar */}
        <Navbar 
          wpm={wpm} 
          accuracy={accuracy} 
          errors={errors} 
          time={time}  
          cpm={cpm}
          kph={kph} 
        />

        {/* Main content with top padding to prevent overlap with fixed navbar */}
        <div className="flex pt-16">
          {/* Left Sidebar - Always visible on desktop, hamburger on mobile */}
          <Sidebar
            languages={allLanguages}
            currentLanguage={currentLanguage}
            setCurrentLanguage={setCurrentLanguage}
            lessons={lessonsData[currentLanguage]}
            currentLesson={currentLesson}
            setCurrentLesson={selectLesson}
          />

          {/* Desktop Layout - Typing Box and Right Sidebar side by side */}
          <div className="hidden md:flex flex-1">
            {/* Typing Box - Takes remaining space with fixed height */}
            <div className="flex-1 p-1">
              <TypingBox
                lesson={currentLesson}
                wpm={wpm}
                accuracy={accuracy}
                errors={errors}
                time={time}
                setWpm={setWpm}
                setAccuracy={setAccuracy}
                setErrors={setErrors}
                setTime={setTime}
                onPrev={goPrevLesson}
                onNext={goNextLesson}
                setCpm={setCpm}
                setKph={setKph}
              />
            </div>

            {/* Right Sidebar - Fixed width */}
            <SidebarRight />
          </div>

          {/* Mobile Layout - Typing Box with auto height, Right Sidebar below */}
          <div className="flex-1 flex flex-col md:hidden w-full">
            {/* Typing Box - Full width with auto height */}
            <div className="w-full p-1">
              <TypingBox
                lesson={currentLesson}
                wpm={wpm}
                accuracy={accuracy}
                errors={errors}
                time={time}
                setWpm={setWpm}
                setAccuracy={setAccuracy}
                setErrors={setErrors}
                setTime={setTime}
                onPrev={goPrevLesson}
                onNext={goNextLesson}
                setCpm={setCpm}
                setKph={setKph}
              />
            </div>
            
            {/* Right Sidebar - Full width below typing box */}
            <div className="w-full p-1">
              <SidebarRight />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;